import { useCallback } from 'react';

import { TFunction } from 'i18next';

import { useComplianceExperience } from '~/hooks/useComplianceExperience';
import { getSubscriptionMenuTitle } from '~/modules/settings/helpers/getSubscriptionMenuTitle';

export const useSubscriptionMenuTitle = (): ((t: TFunction) => string) => {
  const experience = useComplianceExperience();

  return useCallback(
    (t: TFunction) => getSubscriptionMenuTitle(t, experience.id),
    [experience.id],
  );
};
